import * as React from "react";
import Container from "./styled";
import { Fade } from "react-awesome-reveal";

export default function RightText({ subTitle, text, image }) {
  return (
    <Container>
      {/* Text Image Container */}
      <div className="textImageContainer">
        {/* Ilustration Image */}
        <Fade
          direction="left"
          delay={100}
          duration={800}
          triggerOnce={true}
          className="imageContainer"
        >
          <img src={image}></img>
        </Fade>
        {/* Text */}
        <p className="opacidad04">
          <h3>{subTitle}</h3>
          {text}
        </p>
      </div>
    </Container>
  );
}
